import { useUserStatus } from "../hooks/useUserStatus";
import { formatLastSeen } from "utils/lastSeen";

// Sem registro de presença não há "visto há X": antes o componente respondia
// "há uma semana" para qualquer pessoa sem dado — inclusive quem tinha acabado
// de entrar — e isso é informação inventada sobre outro usuário.
const lastSeenLabel = (timestamp) =>
  timestamp ? `Visto ${formatLastSeen(timestamp)}` : "Offline";

/**
 * Componente simples para exibir o status de presença inline
 * Útil para perfis, chat headers, etc.
 */
export const PresenceIndicator = ({
  userId,
  showLabel = true,
  size = "md",
}) => {
  const { state, last_seen } = useUserStatus(userId);
  const isOnline = state === "online";

  const sizeClasses = {
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  };

  if (!showLabel) {
    return (
      <div
        className={`${sizeClasses[size]} rounded-full ${
          isOnline ? "bg-green-500" : "bg-gray-400"
        }`}
        title={isOnline ? "Online" : lastSeenLabel(last_seen)}
      />
    );
  }

  return (
    <div className="flex items-center gap-2">
      <div
        className={`${sizeClasses[size]} rounded-full ${
          isOnline ? "bg-green-500" : "bg-gray-400"
        }`}
      ></div>
      <span className="text-sm text-muted-foreground">
        {isOnline ? (
          <span className="text-success font-medium">Online</span>
        ) : (
          <span>{lastSeenLabel(last_seen)}</span>
        )}
      </span>
    </div>
  );
};
